__turbopack_context__.v({
  "apple_logo": "XBdH8q_apple_logo",
  "create_account": "XBdH8q_create_account",
  "disclaimer": "XBdH8q_disclaimer",
  "email_btn": "XBdH8q_email_btn",
  "facebook_logo": "XBdH8q_facebook_logo",
  "google_logo": "XBdH8q_google_logo",
  "my_list_blurb": "XBdH8q_my_list_blurb",
  "or": "XBdH8q_or",
  "pbs_head_logo": "XBdH8q_pbs_head_logo",
  "signin_modal": "XBdH8q_signin_modal",
  "signin_modal_inner": "XBdH8q_signin_modal_inner",
  "social_btn": "XBdH8q_social_btn",
});
